import _ from 'lodash';
import { CountryRegex } from './country-regex';

export class AppConstant {

  public static PAGE_SIZE = 20;
  public static MAX_PAGE_NUMBERS = 10;
  public static MAX_PAGE_NUMBERS_MOBILE = 5;
  public static NETWORK_TIMEOUT = 900000;//60000;

  public static SUBMIT_SUCCESS_MESSAGE = 'Submitted successfully';
  public static UPDATED_SUCCESS_MESSAGE = 'Updated successfully';
  public static CANCEL_SUCCESS_MESSAGE = 'Cancelled successfully';
  public static SUCCESS_APPROVE = 'Approved successfully';
  public static SUCCESS_DISAPPROVE = 'Disapproved successfully';
  public static SAVE_SUCCESS_MESSAGE = 'Save successfully';
  public static DELETE_SUCCESS_MESSAGE = 'Delete successfully';
  public static CONFIRM_DELETE_MESSAGE = 'Are you sure to delete this item ?';
  public static CONFIRM_DELETE_TITLE = 'Delete';
  public static FILTER_BUTTON = "Filter";

  public static INVALID_DATE_TEXT = 'Invalid Date';
  public static DEFAULT_DATE_FORMAT = 'dd/MM/yyyy';
  public static BOUNDARY_LINKS = false;
  public static DEFAULT_DATE_TIME_FORMAT = 'dd/MM/yyyy HH:mm:ss';
  public static DEFAULT_TIME_FORMAT = 'HH:mm:ss';
  public static FIRST_DAY_OF_WEEK = [7];

  public static SCANNER_FORMAT = ["code_128_reader","ean_reader","ean_8_reader","code_39_reader","code_39_vin_reader","codabar_reader","upc_reader","upc_e_reader","i2of5_reader","2of5_reader","code_93_reader"];

  public static ROLE = {
    ADMIN: 'ADMIN',
    SUPERUSER: 'SUPERUSER',
    USER: 'USER',
    AGENT: 'AGENT'
  }

  public static DATE_CONFIG = {
    dateInputFormat: 'YYYY/MM/DD',
    isAnimated: true,
    selectWeek: true,
    icon: 'fas fa-calendar-alt text-secondary',
    showIcon: true,
    containerClass: 'theme-dark-blue',
    showWeekNumbers: false
  }

  public static PRINT_TYPE = {
    NEWCONSIGNMENTNOTE: 'NewConsignmentNote',
    SHIPPING_LABEL: 'Shipping_Label'
  }

  public static ACTIVITY_TIME_OUT: number = 7200000 // 2 hours
  public static CA_BUSINESS = {
    BUSINESS_ID: "F000305"
  }

  public static VALIDATE = {
    DB_DATE_FORMATE: /^(19|20)\d\d([- /.])(0[1-9]|1[012])\2(0[1-9]|[12][0-9]|3[01])$/,
    EMAIL: '^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$',
    NUMBER: /^(0|[1-9][0-9]*)$/,
    AMOUNT: /^\d+(\.\d{1,2})?$/,
    PHONE_NUMBER: /^(?:\+?\d{1,3}[\s.-]?)?(?:\(?\d{1,4}\)?[\s.-]?)?\d(?:[\s.-]?\d){5,10}$/,
    CHAR: "[^A-Za-z0-9\-/#\s,@./\u4E00-\u9FCC\u3400-\u4DB5\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\ud840-\ud868][\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|[\ud86a-\ud86c][\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d]"
  }

  public static POSTALCODE = CountryRegex;
}

export enum PaymentType {
  CASH = 'Cash',
  ONLINE = 'Online',
  PREPAID = 'Prepaid',
  CREDIT = 'Credit',
  BANK_TRANSFER = 'BankTransfer',
  CHEQUE = 'Cheque '
}
